<template>
  <div class="friendly-link texture-bg-css">
    <div class="w">
      <div class="page-header"><Breadcrumb /></div>
      <ul class="fl-body">
        <li
          class="w-1/4 inline-block cursor-pointer"
          v-for="link in links"
          :key="link.title"
        >
          <span class="fl-icon"></span>
          <span
            class="fl-body-li f-directory-column-section-link"
            @click="windowOpen(link.href)"
          >
            {{ link.title }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb'
import link from '@/core/mixins/link'
export default {
  name: 'friendly-link',
  components: {
    Breadcrumb
  },
  mixins: [link],
  computed: {
    links() {
      let data = this.$store.getters['HomeStore/friendlyLink']
      return data
    }
  },
  methods: {
    windowOpen(url) {
      window.open(url)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.friendly-link {
  min-height: 80vh;
  .fl-body {
    padding: 15px;
    .fl-body-li {
      line-height: 3;
      font-size: 14px;
      color: $c-white;
      &:hover {
        transition: all 0.35s;
        -moz-transition: all 0.35s;
        -webkit-transition: all 0.35s;
        -o-transition: all 0.35s;
        color: $c-hover;
      }
    }
  }
  .fl-icon {
    padding: 0 10px 0 12px;
    background-image: url('../../../static/images/listDetails/attachment-icon.png');
    background-size: 6px 13px;
    background-repeat: no-repeat;
    background-position: 6px 4px;
  }
}
</style>
